<div class="tabbable__body rounded-top-right shadow-z-1 no-margin">
  <h3>Här kan du redigera maxuttaget för tillgängliga frekvenstak</h3>

  @if (show.estimatesHaveChanged) {
    <import-warning></import-warning>
  }


    <div class="container">
      <div class="left-item">
        @if (show?.isEditing) {
          <button
            class="button primary"
            (click)="save()"
            [disabled]="frequencyLimits.invalid"
          >
            Spara
          </button>
          <button class="link" (click)="cancelEditing()">Avbryt redigering</button>
        } @else {
          <button class="button primary" (click)="setEditing(true)">
            Redigera maxuttag
          </button>
        }
      </div>

      <div class="right-item">
        <div class="display--flex">
          @if (productFormats()?.length > 1) {
            <div class="filter-dropdown margin-left--2x dropdown">
              <woo-dropdown
                [items]="productFormats()"
                [(ngModel)]="selectedProductFormat"
                name="selectedProductFormat"
                inputId="select-product-format"
                labelText="Filtrera på Placering"
                [labelTransform]="translateProductFormat"
                notFoundText="Inga Placeringar hittades."
                [clearable]="true"
              ></woo-dropdown>
            </div>
          }

          @if (publishers()?.length > 1) {
            <div class="filter-dropdown margin-left--2x dropdown">
              <woo-dropdown
                [items]="publishers()"
                [(ngModel)]="selectedPublisher"
                name="selectedPublisher"
                inputId="select-publisher"
                labelText="Filtrera på Publicist"
                notFoundText="Inga publicister hittades."
                [clearable]="true"
              ></woo-dropdown>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="sticky-header">
      <h3>Tillgängliga frekvenstak</h3>
    </div>
    <form #frequencyLimits="ngForm">

    <app-woo-table
      [data]="computedValues()"
      (dataChange)="frequencyLimitRows.set($event)"
      [debug]="false"
      [loaderTpl]="loader"
    >
      <column-parent
        title="Maxuttag"
        [children]="['frequencyRatioPreroll','frequencyRatioMidroll','frequencyRatioPostroll']">
      </column-parent>

      <woo-table-column header="Namn" name="name"></woo-table-column>
      <woo-table-column header="Publicist" name="publisherName"></woo-table-column>
      <woo-table-column header="Placering" name="productFormat"></woo-table-column>
      <woo-table-column header="Impressions" name="impressions"></woo-table-column>

      <woo-table-column header="Preroll" name="frequencyRatioPreroll">
        <ng-template let-cell>
          @if (show.isEditing) {
            <div class="input__container in">
              <input
                class="w-full"
                [name]="'row-' + cell.rowIndex + '-' + cell.columnKey"
                [ngModel]="$any(cell.row)[cell.columnKey]"
                (ngModelChange)="onRatioChange(cell, $event, cell.columnKey)"
                wooPercentFormatter
                [wooMinValidator]="0"
                [wooMaxValidator]="1"
                [required]="includedProductFormatSlotTypes[cell.row.productFormatId]['preroll']"
                [disabled]="!includedProductFormatSlotTypes[cell.row.productFormatId]['preroll']"
                />
              </div>
          } @else {
            <span>{{ cell.value ? (cell.value | percent) : '-' }}</span>
          }
        </ng-template>
      </woo-table-column>

      <woo-table-column header="Midroll" name="frequencyRatioMidroll">
        <ng-template let-cell>
          @if (show.isEditing) {
            <div class="input__container in">
              <input
                class="w-full"
                [name]="'row-' + cell.rowIndex + '-' + cell.columnKey"
                [ngModel]="$any(cell.row)[cell.columnKey]"
                (ngModelChange)="onRatioChange(cell, $event, cell.columnKey)"
                wooPercentFormatter
                [wooMinValidator]="0"
                [wooMaxValidator]="1"
                [required]="includedProductFormatSlotTypes[cell.row.productFormatId]['midroll']"
                [disabled]="!includedProductFormatSlotTypes[cell.row.productFormatId]['midroll']"
                />
              </div>
          } @else {
            <span>{{ cell.value ? (cell.value | percent) : '-' }}</span>
          }
        </ng-template>
      </woo-table-column>

      <woo-table-column header="Postroll" name="frequencyRatioPostroll">
        <ng-template let-cell>
          @if (show.isEditing) {
            <div class="input__container in">
              <input
                class="w-full"
                [name]="'row-' + cell.rowIndex + '-' + cell.columnKey"
                [ngModel]="$any(cell.row)[cell.columnKey]"
                (ngModelChange)="onRatioChange(cell, $event, cell.columnKey)"
                wooPercentFormatter
                [wooMinValidator]="0"
                [wooMaxValidator]="1"
                [required]="includedProductFormatSlotTypes[cell.row.productFormatId]['postroll']"
                [disabled]="!includedProductFormatSlotTypes[cell.row.productFormatId]['postroll']"
                />
              </div>
          } @else {
            <span>{{ cell.value ? (cell.value | percent) : '-' }}</span>
          }
        </ng-template>
      </woo-table-column>
    </app-woo-table>

    @if (show.isEditing) {
      <div class="margin-top--2x">
        <button class="button primary" (click)="save()" [disabled]="frequencyLimits.invalid">
          Spara
        </button>
        <button class="link" (click)="cancelEditing()">Avbryt redigering</button>
      </div>
    }

  </form>
</div>

<ng-template #loader let-data>
  <div class="text-center w-100">
    @if (show.loading) {
      <dot-loader [large]="true"></dot-loader>
    } @else {
      <span>Ingen data tillgänglig</span>
    }
  </div>
</ng-template>
